import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NgbActiveModal, NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditLicenseComponent } from '../../../modules/user/components/edit-license/edit-license.component';

@Component({
    selector: 'app-buy-license',
    templateUrl: './buy-license.component.html',
    styleUrls: ['./buy-license.component.scss'],
    providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class BuyLicenseComponent {
  public constructor(public activeModal: NgbActiveModal, private modal: NgbModal) {}

  onActivateCode() {
    this.modal.open(EditLicenseComponent);
    this.activeModal.close();
  }

  onGoToEshop() {
    window.open('https://eshop.isophi.cz/produkt/rodicovska-povidla', '_blank');
    this.activeModal.close();
  }
}
